
  <!-- <button class="signature-toolbar-btn" mat-button color="primary" (click)="copySignature()"><mat-icon class="signature-toolbar-btn-icon">done</mat-icon></button> -->
<button class="signature-toolbar-btn" mat-button color="primary" (click)="openSignatureOptions()"><mat-icon class="signature-toolbar-btn-icon">settings</mat-icon></button>
<button class="signature-toolbar-btn" mat-button color="warn" (click)="removeSignature()"><mat-icon class="signature-toolbar-btn-icon">delete</mat-icon></button>


